import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';
import { HTTPMethod } from '../httpMethods';

export const createDepartmentSourceField = async <
  T extends Record<string, unknown>,
>({
  query,
  departmentId,
  domain,
  headers,
  sourceField,
}: FetchRequestArgs & {
  departmentId: string;
  // @todo - what is a source field?
  sourceField: Record<string, unknown>;
}): Promise<ReturnType<typeof fetchRequest>> =>
  fetchRequest<T>({
    data: sourceField,
    domain,
    endpoint: `/sources/${departmentId}/fields`,
    headers,
    method: HTTPMethod.POST,
    query,
  });
